/* tslint:disable */
/* eslint-disable */
export enum HasLogin {
  True = 'True',
  False = 'False',
  Unknown = 'Unknown'
}
